import { defineStore } from 'pinia'
import { VueYandexMaps } from 'vue-yandex-maps'

import { STATE_OF_MAP } from '@/constants/statesOfAddressSystem'

import { StoreId } from '@/store'
import type { MapSettings } from '@/store/city/city.types'
import type { MapSettingsState } from '@/store/map-settings/map-settings.types'

import { Success } from '@/api/results'

const defaultState: MapSettingsState = {
  stateLoadMap: STATE_OF_MAP.loading,
  mapSettings: {
    service_settings: {
      api_key: '',
      coords: [0, 0],
      zoom: 16,
      provider: '',
    },
    geocode_settings: {
      api_key: '',
      provider: '',
    },
    suggestion_settings: {
      api_key: '',
      provider: '',
    },
  },
}

export const useMapSettingsStore = defineStore(StoreId.MAP_SETTINGS, {
  state: (): MapSettingsState => defaultState,
  actions: {
    setMapSettings(mapSettings: MapSettings | null) {
      this.mapSettings = mapSettings || this.mapSettings
    },
    setStateLoadMap(status: VueYandexMaps.LoadStatus) {
      this.stateLoadMap = status
    },
    async fetchMapSettings() {
      const { $apiService } = useNuxtApp()

      const result = await $apiService.city.fetchMapSettings()

      if (result instanceof Success) {
        this.setMapSettings(result.data)
      }
    },
  },
  getters: {
    mapProviderName: ({ mapSettings }) =>
      mapSettings?.service_settings?.provider,
    mapProviderApiKey: ({ mapSettings }) =>
      mapSettings?.service_settings?.api_key,
    suggestionProviderApiKey: ({ mapSettings }) =>
      mapSettings?.suggestion_settings?.api_key,
    suggestionProviderName: ({ mapSettings }) =>
      mapSettings?.suggestion_settings?.provider,
    getCoords: ({ mapSettings }) => {
      return {
        longitude: mapSettings?.service_settings?.coords[1],
        latitude: mapSettings?.service_settings?.coords[0],
      }
    },
    zoom: ({ mapSettings }) => mapSettings?.service_settings?.zoom,
  },
})
